module.exports = __webpack_public_path__ + "img/picture_ksdgfz02.2d3b090a.png";